import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "content title"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "时间"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "胜"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "平"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "负"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "胜率"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "平率"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "负率")])], -1);
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_5 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_6 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_7 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_8 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_9 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_10 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_13 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_14 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
const _hoisted_15 = {
  style: {
    "font-size": "12px",
    "padding": "0 12px"
  }
};
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
export default {
  __name: 'BeiDanView',
  setup(__props, {
    expose: __expose
  }) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const title = ref('');
    const isListVisible = ref(false);
    const active = ref(0);
    const oddsList = ref([{
      "sp1": "",
      "sp2": "",
      "sp3": ""
    }]);
    const loading = ref(false);
    const id = ref("");
    const handicap1 = ref("");
    const item = ref({});
    // 显示弹出框
    const show = (matchId, match) => {
      isListVisible.value = true;
      item.value = match;
      id.value = matchId;
      active.value = 0;
      title.value = match.homeTeamAbbName + ' VS ' + match.awayTeamAbbName;
      if (match.sectionsNo999 != '') {
        title.value = match.homeTeamAbbName + ' ' + match.sectionsNo999 + ' ' + match.awayTeamAbbName;
      }
      handicap1.value = "";
      oddsList.value = [[{
        "sp1": "",
        "sp2": "",
        "sp3": ""
      }]];
      getOdds(matchId);
    };

    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };
    const styleColor = (val1, val2) => {
      if (Number(val1) > Number(val2)) {
        return "color:red";
      } else if (Number(val1) < Number(val2)) {
        return "color:green";
      } else {
        return "";
      }
    };
    const getTime = time => {
      // 将字符串转换为Date对象
      const date = new Date(time);

      // 提取小时和分钟
      const hours = date.getHours(); // 获取小时数 (0-23)
      const minutes = date.getMinutes(); // 获取分钟数 (0-59)
      return (hours > 9 ? hours : "0" + hours) + ":" + (minutes > 9 ? minutes : "0" + minutes);
    };
    const getOdds = async matchId => {
      loading.value = true;
      const response = await axios.post('https://tuhaojie.asia/api-foot/beijing/selectBeiJin?matchId=' + matchId);
      //const response = await axios.post('http://127.0.0.1:8888/beijing/selectBeiJin?matchId=' + matchId);
      let data = response.data;
      if (data.length > 0) {
        handicap1.value = data[0].handicap;
      }
      oddsList.value = data;
      loading.value = false;
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_table = _resolveComponent("var-table");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isListVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isListVisible.value = $event),
        closeable: "",
        style: {
          padding: '30px 10px',
          height: '85%',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, "北单(" + _toDisplayString(handicap1.value) + ")" + _toDisplayString(title.value), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_var_row, null, {
          default: _withCtx(() => [_createVNode(_component_var_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_var_row, null, {
              default: _withCtx(() => [_createVNode(_component_var_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_var_loading, {
                  description: "加载中",
                  loading: loading.value
                }, {
                  default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_var_table, {
                    "scroller-height": "700",
                    "full-width": "80%"
                  }, {
                    default: _withCtx(() => [_hoisted_2, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oddsList.value, (item, index) => {
                      return _openBlock(), _createElementBlock(_Fragment, {
                        key: index
                      }, [index == oddsList.value.length - 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [_createElementVNode("td", _hoisted_4, _toDisplayString(getTime(item.createTime)), 1), _createElementVNode("td", _hoisted_5, _toDisplayString(item.sp1), 1), _createElementVNode("td", _hoisted_6, _toDisplayString(item.sp2), 1), _createElementVNode("td", _hoisted_7, _toDisplayString(item.sp3), 1), _createElementVNode("td", _hoisted_8, _toDisplayString(item.sp1Rate), 1), _createElementVNode("td", _hoisted_9, _toDisplayString(item.sp2Rate), 1), _createElementVNode("td", _hoisted_10, _toDisplayString(item.sp3Rate), 1)])) : (_openBlock(), _createElementBlock("tr", _hoisted_11, [_createElementVNode("td", _hoisted_12, _toDisplayString(getTime(item.createTime)), 1), _createElementVNode("td", {
                        style: _normalizeStyle([{
                          "font-size": "12px",
                          "padding": "0 12px"
                        }, styleColor(item.sp1, oddsList.value[index + 1].sp1)])
                      }, _toDisplayString(item.sp1), 5), _createElementVNode("td", {
                        style: _normalizeStyle([{
                          "font-size": "12px",
                          "padding": "0 12px"
                        }, styleColor(item.sp2, oddsList.value[index + 1].sp2)])
                      }, _toDisplayString(item.sp2), 5), _createElementVNode("td", {
                        style: _normalizeStyle([{
                          "font-size": "12px",
                          "padding": "0 12px"
                        }, styleColor(item.sp3, oddsList.value[index + 1].sp3)])
                      }, _toDisplayString(item.sp3), 5), _createElementVNode("td", _hoisted_13, _toDisplayString(item.sp1Rate), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(item.sp2Rate), 1), _createElementVNode("td", _hoisted_15, _toDisplayString(item.sp3Rate), 1)]))], 64);
                    }), 128))])]),
                    _: 1
                  })])]),
                  _: 1
                }, 8, ["loading"])]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};